
import React, { useEffect, useState } from "react";
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom"
import validateBonus from "../utils/validate-bonus";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'

export default function WeeklyBonus() {
    // const locale = useSelector((state) => state.globalContent.data.locale);
    const user = useSelector((state) => state.user.data);
    const userLoggedIn = useSelector((state) => state.user.isLoggedIn);
    const bonuses = useSelector((state) => state.bonuses.list);
    const bonusArray = Object.entries(bonuses).filter(([key, bonus]) => key.includes('WEEKLY_SPECIAL'))[0];
    const bonus = bonusArray ? bonusArray[1] : null;

    useEffect(() => {
        // console.log(locale)
    });

    return (
        <>
            {

                bonus && (!userLoggedIn || validateBonus(bonus, user, 'DEPOSIT', false)) && (
                    <Container fluid="lg" className="section-margin weekly-bonus-section" >
                        <div className="weekly-bonus-tile-container" >
                            <Timer />
                            <div className="weekly-bonus-image-wrapper">
                                <img className="weekly-bonus-image" src={bonus?.text?.imageUrl} alt="" />
                            </div>
                            <div className="weekly-bonus-tile-content">
                                <div className="weekly-bonus-tile-content-inner">
                                    <span className="weekly-bonus-badge mb-0">
                                        {bonus?.text?.badge || 'WEEKLY SPECIAL'}
                                    </span>
                                    <h2 className="subtitle white-100 mb-1">{bonus?.text?.title}</h2>
                                    {
                                        !bonus?.text?.subtitle ? null :
                                            <p className="">{bonus.text.subtitle}</p>
                                    }
                                </div>
                                <div className="weekly-bonus-tile-buttons">
                                    {
                                        userLoggedIn ? (
                                            <Link to={`profile/deposit/${bonus.promoCode}`} className="btn-main mt-1 mb-1" href="">Claim now</Link>
                                        ) : (
                                            <Link to={`?register`} className="btn-main mt-1 mb-1" href="">Claim now</Link>
                                        )
                                    }
                                    {/* <a className="btn-secondary mt-1 mb-1 ms-3" href={bonus.text.termsUrl}>Learn more</a> */}
                                </div>
                            </div>
                        </div>
                    </Container>
                )
            }
        </>
    )
}

function Timer() {

    const [timer, setTimer] = useState('');

    function startAndEndOfWeek() {

        // If no date object supplied, use current date
        // Copy date so don't modify supplied date
        var now = new Date();

        // set time to some convenient value
        now.setHours(0, 0, 0, 0);

        // Get the previous Monday
        var monday = new Date(now);
        monday.setDate(monday.getDate() - monday.getDay() + 1);

        // Get next Sunday
        var sunday = new Date(now);
        sunday.setDate(sunday.getDate() - sunday.getDay() + 7);

        // Return array of date objects
        //return [monday, sunday];
        return sunday;
    }

    function leadingZero(num) {
        num = num.toString();
        while (num.length < 2) num = "0" + num;
        return num;
    }

    useEffect(() => {
        const sunday = startAndEndOfWeek();
        let weekEndDay = new Date(sunday);
        let today = new Date();

        let _second = 1000;
        let _minute = _second * 60;
        let _hour = _minute * 60;
        let _day = _hour * 24;
        let distance = Date.parse(weekEndDay) - Date.parse(today);

        // console.log(new Date(sunday).toISOString())
        // console.log(new Date().toISOString())

        let days = Math.floor(distance / _day);
        let seconds = Math.floor((distance / 1000) % 60);
        let minutes = Math.floor((distance / 1000 / 60) % 60);
        let hours = Math.floor((distance / 1000 / 60 / 60) % 24);

        const timeout = setTimeout(() => {
            setTimer(`${leadingZero(days)}:${leadingZero(hours)}:${leadingZero(minutes)}:${leadingZero(seconds)}`)
        }, 1000);

        return () => {
            clearTimeout(timeout);
        }
    }, [timer])

    return (
        <div className="weekly-bonus-timer-container">
            <div className="weekly-bonus-timer-wrapper">
                <FontAwesomeIcon icon={faClock} className="white-100 me-2" />
                <span className="weekly-bonus-expires-in mb-1">Expires in:&nbsp;&nbsp;</span>
                <span className="weekly-bonus-timer mb-0">{timer}</span>
            </div>
        </div>
    )
}